import { Button, Menu, MenuItem } from '@material-ui/core';
import React, { useState } from 'react';
import AddCommentModal from './modals/AddCommentModal';
import FinalizarOcorrenciaModal from './modals/FinalizarOcorrenciaModal';

interface ActionsMenuProps {
	ocorrenciaId: number;
	disabled: boolean;
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({ ocorrenciaId, disabled }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event: { currentTarget: any }) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const [isAddCommentModalOpen, setIsAddCommentModalOpen] = useState(false);
	const [isFinalizarOcorrenciaModalOpen, setIsFinalizarOcorrenciaModalOpen] = useState(false);

	return (
		<div>
			<Button
				aria-controls='simple-menu'
				aria-haspopup='true'
				onClick={handleClick}
				style={{
					backgroundColor: '#1e3a8a',
					color: '#ffffff',
					padding: '3px 24px',
					fontSize: '1.2rem',
					marginTop: '7px',
					textTransform: 'none',
					fontWeight: 'normal',
					width: '9vw',
				}}
			>
				Ações
			</Button>
			<Menu id='simple-menu' anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
				<MenuItem onClick={() => setIsAddCommentModalOpen(true)} disabled={disabled}>
					Adicionar Comentário
				</MenuItem>
				<MenuItem onClick={() => setIsFinalizarOcorrenciaModalOpen(true)} disabled={disabled}>
					Finalizar Ocorrência
				</MenuItem>
			</Menu>
			{isAddCommentModalOpen ? (
				<AddCommentModal
					closeAddCommentModal={() => setIsAddCommentModalOpen(false)}
					ocorrenciaId={ocorrenciaId}
				/>
			) : null}
			{isFinalizarOcorrenciaModalOpen ? (
				<FinalizarOcorrenciaModal
					closeFinalizarOcorrenciaModal={() => setIsFinalizarOcorrenciaModalOpen(false)}
					ocorrenciaId={ocorrenciaId}
				/>
			) : null}
		</div>
	);
};

export default ActionsMenu;
